import React, { useState, useCallback } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import MultiSelectDropdown from './multiSelectDropdown';

const FilterOrders = ({ searching }) => {
  const [isSearching, setIsSearching] = useState(false);
  const [infoForm, setInfoForm] = useState({
    state: [],
    placa: '',
    applicant: '',
    init_date: '',
    end_date: '',
  });

  const stateOptions = [
    { value: 'created', label: 'Creada' },
    { value: 'cancelled', label: 'Cancelada' },
    { value: 'convert', label: 'Convertida' },
    { value: 'finished', label: 'Finalizada' },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInfoForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleStateChange = (newValues) => {
    setInfoForm((prevForm) => ({
      ...prevForm,
      state: newValues,
    }));
  };

  const localSearch = useCallback(async () => {
    setIsSearching(true);
    await searching(infoForm);
    setIsSearching(false);
  }, [infoForm, searching]);

  return (
    <Container className="p-4">
      <Form>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Estado</Form.Label>
              <MultiSelectDropdown
                value={infoForm.state}
                onChange={handleStateChange}
                options={stateOptions}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Placa Vehículo</Form.Label>
              <Form.Control
                name="placa"
                value={infoForm.placa}
                type="text"
                className="fw-bold text-uppercase"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Solicitante</Form.Label>
              <Form.Control
                name="applicant"
                value={infoForm.applicant}
                type="text"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <Form.Group>
              <Form.Label>Fecha Inicio</Form.Label>
              <Form.Control
                name="init_date"
                value={infoForm.init_date}
                type="date"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Fecha Fin</Form.Label>
              <Form.Control
                name="end_date"
                value={infoForm.end_date}
                type="date"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={4}>
            <Button
              onClick={localSearch}
              variant="outline-primary"
              disabled={isSearching}
              className="w-100"
            >
              {isSearching ? 'Buscando...' : 'Buscar'}
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default FilterOrders;